module.exports = __webpack_public_path__ + "img/china.51e3635f.png";